module.exports = __webpack_public_path__ + "static/biznesmen-calculator-min.7455ae31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/universal/img/biznesmen-calculator-min.jpg
// module id = 809
// module chunks = 168707334958949